import { render, staticRenderFns } from "./Tagcategories.vue?vue&type=template&id=1a1e3b69&"
import script from "./Tagcategories.vue?vue&type=script&lang=js&"
export * from "./Tagcategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Tagcategories.vue"
export default component.exports